<template>
    <a aria-label="general search"
       class="relative z-30 flex items-center px-3 py-2 mr-3 text-xs text-gray-400 transition-colors duration-200 ease-out border border-t-0 border-b-2 search-open border-zinc-100 hover:border-clay-500 border-x-0 hover:text-gray-800 hover:shadow-2xl "
       href="#"
       v-on:click.prevent="openSearch">
        <MagnifyingGlassIcon aria-hidden="true" class="inline-block w-5 h-5 mr-2 text-gray-400"/>
        <span class="pr-2 search-txt text-clay-900">Search...</span>
    </a>
</template>

<script lang="ts" setup>
// @ts-ignore
import {ref} from "vue";
import {MagnifyingGlassIcon} from '@heroicons/vue/20/solid';
import {store} from "@/store";

const openSearch = async () => {
    store.openSearchDialog = true;
};

</script>
<style>

</style>